<template>
	<div class="form-group" :class="{'has-error': hasError}">
		<label v-if="label" :for="name" class="col-sm-4 col-md-6 control-label control-label-toggle"><i v-if="icon" class="fa fa-{{icon}}"></i> {{label}}</label>

		<div :class="{'col-sm-8 col-md-6': label}">
			<div class="checkbox">
				<input type="checkbox" :id="name"
					v-toggle="vmodel"
					:on="on"
					:off="off"
					:on-style="onStyle"
					:off-style="offStyle">
			</div>

			<!-- ERROR -->
			<span v-if="hasError" class="help-block"><i class="fa fa-exclamation-triangle"></i> {{ errorMessage }}</span>
		</div>
	</div>

</template>

<script>
	import props from './props'
	import events from './events'

	export default {
		props,
		events,

		data() {
			return {
				hasError: false,
				errorMessage: null
			}
		}
	}
</script>

<style scoped>
	.input-group {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// input-toggle.vue?03c7ec1a